// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EventTags_wrapper__b9qHN","title":"EventTags_title__A12NT","tagsContainer":"EventTags_tagsContainer__dpmka"};